/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { LoginComponent } from '../login/login.component';
import { HomeComponent } from '../home/home.component';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { SuspendedComponent } from '../suspended/suspended.component';
import { GotoComponent } from '../goto/goto.component';
import { AuthGuard } from '../auth.guard';
import { authRouterConfig } from './auth.routes';
import { settingsRouterConfig } from './settings.routes';
import { contactRouterConfig } from './contact.routes';
import { inboxRouterConfig } from './inbox.routes';
import { configRouterConfig } from './config.routes';
import { adminRouterConfig } from './admin.routes';
import { automateRouterConfig } from './automate.routes';
import { Route } from '../../../node_modules/@angular/router';

export const routerConfig: Route[] = [
  ...authRouterConfig,
  ...settingsRouterConfig,
  ...contactRouterConfig,
  ...inboxRouterConfig,
  ...configRouterConfig,
  ...adminRouterConfig,
  ...automateRouterConfig,
  {
    path: '',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
    data: { role: 'contributor', title: 'Dashboard', uiTitle: 'Dashboard' }
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
    data: { role: 'contributor', title: 'Dashboard', uiTitle: 'Dashboard' }
  },
  {
    path: 'suspended',
    component: SuspendedComponent,
    canActivate: [AuthGuard],
    data: { role: 'contributor', title: 'Account Suspended', uiTitle: 'Account Suspended' }
  },
  {
    path: 'goto/:id',
    component: GotoComponent,
    canActivate: [AuthGuard],
    data: { role: 'contributor', title: 'Drift Email', uiTitle: 'Drift Email' }
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  }

];



// WEBPACK FOOTER //
// ./client/app/routes/root.routes.ts